import * as Select from '@radix-ui/react-select';
import { Fragment } from 'react';

import { DropdownHeading } from '~/chords/Select/components/DropdownSingleSelect/components/DropdownHeading';
import { DropdownItem } from '~/chords/Select/components/DropdownSingleSelect/components/DropdownItem';
import type {
  HeadingTemplateComponent,
  InternalDropdownOption,
  InternalDropdownOptions,
  OptionTemplateComponent,
  RadixUiProps,
} from '~/chords/Select/components/DropdownSingleSelect/types';

interface DropdownItemsProps extends RadixUiProps {
  options: InternalDropdownOptions;
  searchQuery?: string;
  selectedOption?: InternalDropdownOption;
  onSelectOption?: (option: InternalDropdownOption) => void;
  showCheckIcon?: boolean;
  HeadingTemplate?: HeadingTemplateComponent;
  OptionTemplate?: OptionTemplateComponent;
}

export function DropdownItems({
  options,
  searchQuery,
  selectedOption,
  onSelectOption,
  showCheckIcon,
  HeadingTemplate,
  OptionTemplate,
  radix = {},
}: DropdownItemsProps) {
  return (
    <>
      {options.map((group, index) => {
        const hasOptions =
          'options' in group ? group.options.length > 0 : group.length > 0;

        return (
          <Fragment key={index}>
            {hasOptions && index && !searchQuery ? (
              <Select.Separator
                {...radix.selectSeparator}
                className="mx-md my-xs h-px bg-emphasis-subtle"
              />
            ) : null}
            <Select.Group {...radix.selectGroup}>
              {'heading' in group && hasOptions && !searchQuery ? (
                <Select.Label {...radix.selectLabel}>
                  <DropdownHeading
                    group={group}
                    index={index}
                    HeadingTemplate={HeadingTemplate}
                  />
                </Select.Label>
              ) : null}
              {('options' in group ? group.options : group).map((option) => (
                <DropdownItem
                  key={option.value}
                  option={option}
                  selectedOption={selectedOption}
                  onSelectOption={onSelectOption}
                  showCheckIcon={showCheckIcon}
                  searchQuery={searchQuery}
                  OptionTemplate={OptionTemplate}
                  radix={radix}
                />
              ))}
            </Select.Group>
          </Fragment>
        );
      })}
    </>
  );
}

DropdownItems.displayName = 'DropdownItems';
